<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Aclaraciones y Reclamaciones.</li>
      </template>
      <template slot="title">
        Consultas, Aclaraciones y Reclamaciones.
      </template>
      <template slot="body">
        <div class="col-lg-12">
          <div class="section-heading heading-left">
            <!-- UNE -->
            <h2 class="title">¿Qué es la <span class="primary">UNE</span>?</h2>
            <p>
              Con el objetivo de atender de manera inmediata, directa y eficiente las consultas, aclaraciones y
              reclamaciones que sean solicitadas por parte de los usuarios, RedGirasol pone a disposición la
              <strong>Unidad Especializada de Atención a Usuarios (UNE)</strong>.
              <br>

              <a @click.stop="openNewTabWithUrl('https://cdn.redgirasol.com/informativos/Aviso-Datos-UNE.pdf')" class="rg-a">Consulta el Aviso de Datos de la UNE.</a>
            </p>
            <!-- UNE -->

            <!-- PASOS A SEGUIR -->
            <h2 class="title"><span class="primary">Pasos</span> a seguir.</h2>
            <div class="row">
              <div class="col-lg-4">
                <div class="testimonial-grid">
                  <h1 class="mb--10 bold">01.</h1>
                  <span class="social-media black">Descargar.</span>
                  <p>
                    Para comenzar, descarga el formato a llenar dando clic <a
                      href="https://cdn.redgirasol.com/documents/REDGIRASOL%C2%AE_UNE_FORMATO.pdf"
                      target="_blank" rel="noopener noreferrer">aquí</a>. Identifica tu ID de usuario dentro del portal a
                    un lado de tu nombre.
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-grid">
                  <h1 class="mb--10 bold">02.</h1>
                  <span class="social-media black">Enviar.</span>
                  <p>
                    Envía el formato completo al correo <strong>une@redgirasol.com</strong> junto con una copia de tu
                    identificación oficial por ambos lados.
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-grid">
                  <h1 class="mb--10 bold">03.</h1>
                  <span class="social-media black">Consultar.</span>
                  <p>
                    En un plazo máximo de <strong>30 días hábiles</strong> recibirás una respuesta sobre tu consulta,
                    reclamación o aclaración a través de tu mismo correo.
                  </p>
                </div>
              </div>
            </div>
            <!-- PASOS A SEGUIR -->
          </div>
        </div>
      </template>
    </GenericPage>
    <!-- DATOS -->
    <div class="row">
      <div class="col-sm-12 col-md-6 p-0">
        <img class="img-responsive" src="https://cdn.redgirasol.com/green/IMAGENES/HOJACARTA.jpg" alt="">
      </div>
      <div class="col-sm-12 col-md-6 p-5 bg-light">
        <h2 class="title">Datos <span class="primary">importantes</span>.</h2>
        <ul class="mb-4 ul-contacts">
          <li><strong>Nombre titular:</strong> Jorge Armando Cárdenas Tijerina</li>
          <li><strong>Horarios de atención:</strong> Lunes a Viernes de 9:00 a.m. a 6:00 p.m</li>
          <li><strong>Teléfono:</strong> (81) 1107 0504 Ext. 106</li>
          <li><strong>Correo Electrónico:</strong> une@redgirasol.com</li>
        </ul>
        <div class="col-4">
          <button @click.stop="downloadDocument()" class="axil-btn btn-borderd btn-dark">Descargar formato</button>
        </div>
      </div>
    </div>
    <!-- DATOS -->
  </div>
</template>

<script>
import GenericPage from "./new-portal-views/GenericPage.vue";

export default {
  name: "Security Advices",
  components: {
    GenericPage
  },
  data() {
    return {
      contentPage: 1,
    }
  },
  methods: {
    downloadDocument() {
      window.open("https://cdn.redgirasol.com/documents/REDGIRASOL%C2%AE_UNE_FORMATO.pdf", "_blank");
    }
  }
}
</script>

<style scoped>
.section-heading p {
  width: auto;
}

ul {
  list-style: none;
  padding-left: 0;
}

li {
  font-weight: 700;
}

ul.ul-contacts li:before {
  content: '✓';
  margin-right: 1rem;
  color: var(--color-primary);
  font-weight: 700;
}
</style>